import React, { useState, useRef, useEffect } from "react";

import { PictureUploadWrapper } from "./style";
import icon from "../../images/uploadIcon.svg";
import { isEmpty } from "../../Utils/common";
import fileIcon from "../../images/file.png";

const PictureUpload = ({
  setImage = () => {},
  image = "",
  accept = "image/jpeg,image/png,image/jpg",
  type = "image",
}) => {
  const [fileName, setFileName] = useState(null);
  const [preview, setPreview] = useState("");
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    try {
      const selectedFile = event.target.files[0];
      
      // Validate file type based on accept attribute
      if ((accept === "application/pdf" || accept === ".pdf,application/pdf") && 
          selectedFile.type !== "application/pdf" && 
          !selectedFile.name.toLowerCase().endsWith('.pdf')) {
        alert("Please select a PDF file only.");
        event.target.value = ""; // Clear the input
        return;
      }
      
      if (accept.includes("image/") && !selectedFile.type.startsWith("image/")) {
        alert("Please select an image file only.");
        event.target.value = ""; // Clear the input
        return;
      }
      
      // setFile(selectedFile);
      setImage(selectedFile);
      setFileName(selectedFile.name);

      // Handle PDF files differently
      if (selectedFile.type === "application/pdf") {
        setPreview("PDF_FILE"); // Special flag for PDFs
      } else {
        setPreview(URL.createObjectURL(selectedFile));
      }
    } catch (error) {
      console.error("File selection error:", error);
    }
  };

  const handleDrop = (event) => {
    try {
      event.preventDefault();
      const droppedFile = event.dataTransfer.files[0];
      
      // Validate file type based on accept attribute
      if ((accept === "application/pdf" || accept === ".pdf,application/pdf") && 
          droppedFile.type !== "application/pdf" && 
          !droppedFile.name.toLowerCase().endsWith('.pdf')) {
        alert("Please drop a PDF file only.");
        return;
      }
      
      if (accept.includes("image/") && !droppedFile.type.startsWith("image/")) {
        alert("Please drop an image file only.");
        return;
      }
      
      // setFile(droppedFile);
      setImage(droppedFile);
      setFileName(droppedFile.name);
      
      // Handle PDF files differently
      if (droppedFile.type === "application/pdf") {
        setPreview("PDF_FILE"); // Special flag for PDFs
      } else {
        setPreview(URL.createObjectURL(droppedFile));
      }
    } catch (error) {
      console.error("File drop error:", error);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    // setFile(null);
    setImage(null);
    setPreview("");
    setFileName("");
    fileInputRef.current.value = null;
  };

  useEffect(() => {
    if (isEmpty(image)) return;
    setPreview(image);
  }, [image]);

  console.log("preview", preview);
  return (
    <PictureUploadWrapper
      className="file-upload"
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onClick={handleClick}
    >
      {preview ? (
        <>
          {preview === "PDF_FILE" ? (
            // Special handling for PDFs
            <div className="showTextImg">
              <div>
                <span className="remove-icon" onClick={handleRemove}>
                  &#10005;
                </span>
                <img src={fileIcon} alt="" />
                <p style={{
                  marginInline: "0",
                  maxWidth: "100%",
                  textAlign: "center",
                  marginTop: "20px",
                }}>
                  {fileName}
                </p>
                <p style={{
                  marginInline: "0",
                  maxWidth: "100%",
                  textAlign: "center",
                  marginTop: "10px",
                  color: "#0363a3",
                  fontWeight: "bold"
                }}>
                  PDF File Selected ✓
                </p>
              </div>
            </div>
          ) : type === "image" ? (
            <div className="preview-container">
              <img
                src={preview}
                alt="Preview"
                style={{ width: "100%", height: "auto", maxHeight: "200px", objectFit: "contain" }}
              />
              <span className="remove-icon" onClick={handleRemove}>
                &#10005;
              </span>
            </div>
          ) : ( // Other file types (non-PDF, non-image)
            <div className="showTextImg">
              <div>
                <span className="remove-icon" onClick={handleRemove}>
                  &#10005;
                </span>
                <img src={fileIcon} alt="" />
                <p
                  style={{
                    marginInline: "0",
                    maxWidth: "100%",
                    textAlign: "center",
                    marginTop: "20px",
                  }}
                >
                  {fileName}
                </p>
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="showTextImg">
          <div>
            <img src={type === "image" ? icon : fileIcon} alt="" />
            <p style={{ padding: "20px" }}>
              {(accept === "application/pdf" || accept === ".pdf,application/pdf")
                ? "Drag & Drop your PDF file here or click to select a PDF file"
                : "Drag & Drop your file here or click to select a file"
              }
            </p>
          </div>
        </div>
      )}
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept={accept}
        style={{ display: "none" }}
      />
    </PictureUploadWrapper>
  );
};

export default PictureUpload;
